import { LobbyRouter } from './containers';
import { IModule } from 'core/rootInterfaces/root.interface';

export const lobbyModule: IModule = {
  moduleName: 'lobby',
  path: '/',
  component: LobbyRouter,
  reducer: null,
};
